import svg4everybody from 'svg4everybody';
import { triggerLazyloadCallbacks } from './utils/image';
export default function() {
    /**
     * Use external SVG spritemaps
     */
    svg4everybody();

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    /**
     * Trigger lazyload
     */
    triggerLazyloadCallbacks();
}
